import React, { useEffect } from "react";
import PropTypes from "prop-types";

import { SectionContainer } from "../../../components/SectionContainer";
import { Filter } from "../camera-filter/Filter/Filter";
import { DynamicCameraList } from "./DynamicCameraList/DynamicCameraList";

import CameraFilterContext from "./CameraFilterContext";
import CameraComparisonContext from "../camera-comparison/CameraComparisonContext";

import { useCameraFilter } from "../../../lib/hooks/useCameraFilter";
import { useCameraComparison } from "../camera-comparison/useCameraComparison";
import { slugify } from "../../../lib/helper/getAnchorNavData";
import { StaticCameraList } from "./StaticCameraList/StaticCameraList";
import { navigate } from "gatsby";
import { CameraComparison } from "../camera-comparison";

import t from "../../../lib/translate";

export const sectionId = slugify("result-list");

function CameraListing({
    items,
    itemsPerPage,
    currency,
    staticPagedCameras,
    baseUrl,
    lastStaticPage,
    currentStaticPage,
    activeFilters,
    config
}) {
    const filterContext = useCameraFilter({
        allItems: items,
        itemsPerPage,
        activeFilters
    });

    const comparisonContext = useCameraComparison(items);

    useEffect(() => {
        if (filterContext.isFiltered) {
            navigate(`${baseUrl}#${sectionId}`, {
                state: { activeFilters: filterContext.active }
            });
        }
    }, [filterContext.isFiltered]);

    return (
        <CameraFilterContext.Provider value={filterContext}>
            <CameraComparisonContext.Provider value={comparisonContext}>
                <Filter sectionId={sectionId} />

                <SectionContainer>
                    {filterContext.items.length === 0 && (
                        <span>{t("camera.filter.no-results.test")}</span>
                    )}
                    {filterContext.isFiltered ? (
                        <DynamicCameraList
                            sectionId={sectionId}
                            itemsPerPage={itemsPerPage}
                            currency={currency}
                        />
                    ) : (
                        <StaticCameraList
                            staticPagedCameras={staticPagedCameras}
                            baseUrl={baseUrl}
                            currency={currency}
                            lastPage={lastStaticPage}
                            currentPage={currentStaticPage}
                            sectionId={sectionId}
                        />
                    )}
                </SectionContainer>

                <CameraComparison config={config}/>
            </CameraComparisonContext.Provider>
        </CameraFilterContext.Provider>
    );
}

CameraListing.defaultProps = {
    items: [],
    itemsPerPage: 10
};

CameraListing.propTypes = {
    currency: PropTypes.string.isRequired,
    items: PropTypes.array,
    itemsPerPage: PropTypes.number
};

export { CameraListing };
